import { action, observable } from "mobx";

// a task the user just started, before Watson has created it
export const STARTING_TASK = "starting";

// Module-level so the window and what's typed in it survive page navigations, which remount the page tree and
// rebuild its stores. The tasks themselves live in SWR's cache, which is also module-level. Only changed from
// client event handlers, so it stays at its defaults during SSR.
export const siteAssistantSession = observable({
  open: false,
  // the task whose detail is showing, `STARTING_TASK`, or null for a list
  openTaskId: null as string | null,
  // the project showing, or that the open task was opened from; null for home
  openProjectId: null as string | null,
  projectTab: "changes" as "context" | "changes",
  // the composer on home or a project, which always starts a new task
  draft: "",
  // the project a change started from home joins; null for a quick change on its own
  draftProjectId: null as string | null,
  // the detail's box, which refines the task or answers its confirmation
  followUpDraft: "",
  // a sent request, shown until its task holds more than `messageCount` messages; `conversationId` is null until
  // Watson has created a new task
  pendingUser: null as {
    text: string;
    conversationId: string | null;
    messageCount: number;
  } | null,
  sending: false,
  error: null as string | null,
});

export const updateSiteAssistantSession = action(
  (changes: Partial<typeof siteAssistantSession>) => {
    Object.assign(siteAssistantSession, changes);
  },
);
